import { Popper, PopperProps } from './Popper';
import { PopperMenuContainer } from '@nexelem/popper';

type ButtonWithMenuProps = Omit<PopperProps, 'placement' | 'hasBorder'> & {
  readonly disabled?: boolean;
};

export const ButtonWithMenu = ({ disabled, content, ...props }: ButtonWithMenuProps) => (
  <Popper
    {...props}
    content={(popupState) => <PopperMenuContainer>{content(popupState)}</PopperMenuContainer>}
    disabled={disabled}
    hasBorder={false}
    placement="bottom-start"
  />
);
ButtonWithMenu.displayName = 'ButtonWithMenu';
